<div class="modal-header noselect">
  <h2 class="modal-title">Transfer Vehicle</h2>
  <button type="button" class="btn-close" (click)="onCancel()" [disabled]="isSubmitting">
    <span class="fa-solid fa-xmark"></span>
  </button>
</div>

<!-- cdkScrollable: lets the owner typeahead's overlay reposition when this
     scrolls. Element scroll events do not reach CDK's document listener. -->
<div class="modal-body" cdkScrollable>
  <p class="vehicle-summary noselect">
    <span class="fa-solid fa-car me-2"></span>
    <strong>{{ vehicleName }}</strong>
    <span class="text-muted"> &mdash; currently owned by {{ currentOwnerName }}</span>
  </p>

  <!-- Step 1: choose the new owner -->
  <div *ngIf="step === 'owner'" class="form-section">
    <h3 class="section-title noselect">New Owner</h3>
    <app-user-search-typeahead
      [placeholder]="'Search for the new owner...'"
      [selectedUser]="selectedUser"
      (userSelected)="onUserSelected($event)"
    ></app-user-search-typeahead>
  </div>

  <!-- Step 2: merge or keep separate, then confirm -->
  <div *ngIf="step === 'confirm'" class="form-section">
    <h3 class="section-title noselect">Confirm Transfer</h3>

    <p class="transfer-line">
      Move <strong>{{ vehicleName }}</strong> from <strong>{{ currentOwnerName }}</strong>
      to <strong>{{ newOwnerName }}</strong>.
    </p>

    <div *ngIf="candidates.length > 0" class="merge-section">
      <p class="merge-prompt">
        {{ newOwnerName }} already has
        {{ candidates.length === 1 ? 'a vehicle that looks like' : 'vehicles that look like' }}
        this one. Merge them into a single record, or keep them separate?
      </p>

      <label *ngFor="let candidate of candidates" class="merge-option">
        <input
          type="radio"
          name="mergeChoice"
          [value]="candidate.VehicleId"
          [(ngModel)]="mergeChoice"
          [disabled]="isSubmitting"
        />
        <span class="merge-option-body">
          <span class="merge-option-title">
            Merge into {{ candidateName(candidate) }}
            <span class="match-badge">{{ matchLabel(candidate) }}</span>
          </span>
          <span class="merge-option-meta">
            <span *ngIf="candidate.Vin">VIN {{ candidate.Vin }}</span>
            <span *ngIf="candidate.LicensePlate">
              Plate {{ candidate.LicensePlate }}<span *ngIf="candidate.PlateState"> ({{ candidate.PlateState }})</span>
            </span>
            <span>{{ candidate.InvoiceCount }} invoice(s), {{ candidate.ImageCount }} image(s)</span>
          </span>
        </span>
      </label>

      <label class="merge-option">
        <input
          type="radio"
          name="mergeChoice"
          value="separate"
          [(ngModel)]="mergeChoice"
          [disabled]="isSubmitting"
        />
        <span class="merge-option-body">
          <span class="merge-option-title">Keep as a separate vehicle</span>
          <span class="merge-option-meta">
            <span>Both records stay in {{ newOwnerName }}'s garage.</span>
          </span>
        </span>
      </label>
    </div>

    <p class="transfer-note noselect">
      <span class="fa-solid fa-circle-info me-2"></span>
      Images and work history follow the vehicle. Past invoices stay billed to
      {{ currentOwnerName }} and will not appear in {{ newOwnerName }}'s invoices.
    </p>
  </div>
</div>

<div class="modal-footer noselect">
  <button
    *ngIf="step === 'confirm'"
    type="button"
    class="btn btn-link"
    (click)="onBack()"
    [disabled]="isSubmitting"
  >
    Back
  </button>
  <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
    Cancel
  </button>
  <button
    *ngIf="step === 'owner'"
    type="button"
    class="btn btn-primary"
    (click)="onContinue()"
    [disabled]="!canContinue"
  >
    <span *ngIf="!isLoadingCandidates">Continue</span>
    <span *ngIf="isLoadingCandidates">
      <span class="spinner-small"></span> Checking...
    </span>
  </button>
  <button
    *ngIf="step === 'confirm'"
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    [disabled]="!canSubmit"
  >
    <span *ngIf="!isSubmitting">{{ selectedCandidate ? 'Merge Vehicles' : 'Transfer Vehicle' }}</span>
    <span *ngIf="isSubmitting">
      <span class="spinner-small"></span> Transferring...
    </span>
  </button>
</div>
